import React, { useState } from "react";
import { usePopper } from 'react-popper';
import { Box, IconButton, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Text, } from '@chakra-ui/react';
import { FaPencil } from "react-icons/fa6";
import { FaChevronDown, FaChevronUp, FaTrash } from "react-icons/fa";
import { useContentManagement } from "./ContentManagementProvider";
export const ContentControls = (props) => {
    var _a;
    const { isEditing } = useContentManagement();
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(props.attachTo, popperElement, { placement: (_a = props.position) !== null && _a !== void 0 ? _a : "top-start" });
    if (!isEditing) {
        return null;
    }
    return (React.createElement(Box, Object.assign({ ref: setPopperElement, zIndex: 1, style: Object.assign({ position: "absolute", left: 0 }, styles.popper) }, attributes.popper, { bg: "white", p: 2, boxShadow: "md", display: "flex", gap: 2, borderRadius: "md", alignItems: "center" }),
        React.createElement(Text, { fontSize: "sm" }, props.label),
        props.children !== undefined &&
            React.createElement(Popover, { closeOnBlur: false },
                React.createElement(PopoverTrigger, null,
                    React.createElement(IconButton, { "aria-label": "Edit", icon: React.createElement(FaPencil, null), size: "xs" })),
                React.createElement(PopoverContent, { minW: "600px", maxHeight: "75vh", overflowY: "scroll" },
                    React.createElement(PopoverArrow, null),
                    React.createElement(PopoverCloseButton, null),
                    React.createElement(PopoverHeader, null, "Edit"),
                    React.createElement(PopoverBody, null, props.children))),
        props.onUp &&
            React.createElement(IconButton, { "aria-label": "Up", icon: React.createElement(FaChevronUp, null), size: "xs", onClick: props.onUp }),
        props.onDown &&
            React.createElement(IconButton, { "aria-label": "Up", icon: React.createElement(FaChevronDown, null), size: "xs", onClick: props.onDown }),
        props.onDelete &&
            React.createElement(IconButton, { "aria-label": "Delete", icon: React.createElement(FaTrash, null), size: "xs", onClick: props.onDelete })));
};
